import apiClient, { unwrap } from './client'
import type { Backup } from './types'
import { useAuthStore } from '@/store/auth'

export const backupsApi = {
  list() {
    return unwrap<Backup[]>(apiClient.get('/backups'))
  },

  create(backupType: string, encrypted = false) {
    return unwrap<{ id: string; status: string }>(
      apiClient.post('/backups', { backup_type: backupType, encrypted }),
    )
  },

  delete(id: string) {
    return unwrap<{ deleted: boolean }>(apiClient.delete(`/backups/${id}`))
  },

  /** 从回收站恢复 */
  restore(id: string) {
    return unwrap<{ id: string; restored: boolean }>(apiClient.put(`/backups/${id}/restore`, {}))
  },

  /** 文件下载:不走 axios，用 fetch + blob */
  async download(id: string) {
    const token = useAuthStore.getState().accessToken
    const res = await fetch(`/api/v1/backups/${id}/download`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    if (!res.ok) throw new Error('下载失败')
    const blob = await res.blob()

    // 从 Content-Disposition 提取文件名
    const cd = res.headers.get('Content-Disposition') || ''
    const match = cd.match(/filename="(.+?)"/)
    const filename = match ? match[1] : `backup-${id}.zip`

    // 触发浏览器下载
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  },
}
